const DEFAULT_STORAGE_KEY = 'dashboardLayout';
const CHANGE_EVENT = 'dashboard-layout-change';

const getLayout = (storageKey = DEFAULT_STORAGE_KEY, fallback = []) => {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
};

const saveLayout = (storageKey = DEFAULT_STORAGE_KEY, layout) => {
  console.log('Saving layout:', layout);
  try {
    localStorage.setItem(storageKey, JSON.stringify(layout));
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { storageKey, layout } }));
    return true;
  } catch {
    return false;
  }
};

const clearLayout = (storageKey = DEFAULT_STORAGE_KEY) => {
  try {
    localStorage.removeItem(storageKey);
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { storageKey, layout: null } }));
    return true;
  } catch {
    return false;
  }
};

const subscribe = (storageKey = DEFAULT_STORAGE_KEY, callback, fallback = []) => {
  const handleStorageEvent = (e) => {
    if (e.key !== storageKey) return;
    try {
      const parsed = e.newValue ? JSON.parse(e.newValue) : fallback;
      callback(Array.isArray(parsed) ? parsed : fallback);
    } catch {
      callback(fallback);
    }
  };

  const handleCustomEvent = (e) => {
    if (e.detail?.storageKey !== storageKey) return;
    callback(e.detail.layout ?? fallback);
  };

  window.addEventListener('storage', handleStorageEvent);
  window.addEventListener(CHANGE_EVENT, handleCustomEvent);

  return () => {
    window.removeEventListener('storage', handleStorageEvent);
    window.removeEventListener(CHANGE_EVENT, handleCustomEvent);
  };
};

//export default { DEFAULT_STORAGE_KEY, getLayout, saveLayout, clearLayout, subscribe };
const layoutService = {
  DEFAULT_STORAGE_KEY,
  getLayout,
  saveLayout,
  clearLayout,
  subscribe,
};

export default layoutService;